import { Injectable } from '@angular/core';
import { UturuncoUtils } from '../../utils/uturuncoUtils';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { Mercaderia } from 'src/app/model/index.model';
import { BaseService } from './base.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MercaderiaService extends BaseService<Mercaderia> {

    constructor(protected override http: HttpClient) {
        super(http, 'mercaderia');
    }

    doFindCode(id) {
        this.other_header = UturuncoUtils.getHeader();

        return firstValueFrom(this.http
            .post(this.api + "/factory/findCode", { query: id }, { headers: this.other_header }));
    }

    searchBySerie(query: string) {
        this.other_header = UturuncoUtils.getHeader();

        return firstValueFrom(this.http
            .get(this.api + "/factory/search?query="+query , { headers: this.other_header }));

    }


    doCoste(id, coste, venta) {
        this.other_header = UturuncoUtils.getHeader();

        return firstValueFrom(this.http
            .post(this.api + "/factory/updateCoste/" + id, { precio: coste, precio2: venta }, { headers: this.other_header }));
    }

    getCatalogo(criteria, page, limit) {
        this.other_header = UturuncoUtils.getHeader();

        return firstValueFrom(this.http
            .post(this.api + "/factory/catalogo/?page=" + page + "&limit=" + limit, { query: criteria }, { headers: this.other_header }));
    }

    getReporteStock(criteria, page, limit) {
        this.other_header = UturuncoUtils.getHeader();

        return firstValueFrom(this.http
            .post(this.api + "/factory/reportestock/?page=" + page + "&limit=" + limit, { query: criteria }, { headers: this.other_header }));
    }
    getReporteStockId(desde, hasta, id) {
        this.other_header = UturuncoUtils.getHeader();

        return firstValueFrom(this.http
            .post(this.api + "/factory/reportestockbyid/", { desde, hasta, id }, { headers: this.other_header }));
    }


}
